export default function livestreamDefinition () {
  return {
    meta: {
      name: null,
      description: null,
      slug: null,
    },
    status: 'draft',
    is_running: false,
    recording_mode: 'none',
    transcoding: {
      enabled: false,
      recording: false,
      orientation: 'horizontal',
      input: {
        id: null,
        tier: 'HD',
        type: 'RTMP_PUSH',
        url: null,
        status: 'draft'
      },
      channel: {
        id: null,
        url: {
          original: null,
          cdn: null,
        },
        status: 'draft',
        renditions: [
          {
            resolution: '1920x1080',
            video: {
              width: 1920,
              height: 1080,
              bitrate: 6000,
              framerate: 30,
            },
            audio: {
              codec: 'aac',
              channel: '2.0',
              bitrate: 160,
            }
          },
          {
            resolution: '1280x720',
            video: {
              width: 1280,
              height: 720,
              bitrate: 3300,
              framerate: 30,
            },
            audio: {
              codec: 'aac',
              channel: '2.0',
              bitrate: 160,
            }
          },
          {
            resolution: '768x432',
            video: {
              width: 768,
              height: 432,
              bitrate: 1100,
              framerate: 30,
            },
            audio: {
              codec: 'aac',
              channel: '2.0',
              bitrate: 160,
            }
          },
          {
            resolution: '640x360',
            video: {
              width: 640,
              height: 360,
              bitrate: 400,
              framerate: 30,
            },
            audio: {
              codec: 'aac',
              channel: '2.0',
              bitrate: 160,
            }
          }
        ],
      }
    },
    scheduling: [],
    ads_enabled: false,
    ads: {
      status: null,
      slate: {
        _id: '',
        url: null,
        gcp_id: null
      },
      ad_tag_uri: null,
      live_config_id: null
    }
  }
}
